// bootstrap.dev.ts - Simple bootstrap for development environment
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

export const bootstrap = () => {
  console.log('Initializing dev bootstrap...');

  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

export default bootstrap;
